module.exports = __webpack_public_path__ + "img/castlecleaners-banner.09bdfd14.jpg";